import { render, staticRenderFns } from "./ThemesList.vue?vue&type=template&id=0972cef6&scoped=true&"
import script from "./ThemesList.vue?vue&type=script&lang=js&"
export * from "./ThemesList.vue?vue&type=script&lang=js&"
import style0 from "./ThemesList.vue?vue&type=style&index=0&id=0972cef6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972cef6",
  null
  
)

export default component.exports